import React, { useEffect, useRef } from "react"

export type BPointWebParamsType = {
    T1: string, // " Value="127.0.0.1" />
    T2: string, // " Value="" /><%-- User Linux --%>
    T3: string, // " Value="" /><%-- Operatore --%>
    T4: string, // " Value="" /><%-- Password Operatore --%>
    T5: string, // " Value="S" /><%-- Flag Download -- Non si modifica --%>
    T6: string, // " Value="" /><%-- Password Linux --%>
    T7: string, // " Value="WEB" /><%-- Tipo Lancio -- Non si modifica --%>
    T8: string, // " Value="" /><%-- Session ID -- Non si modifica --%>
    T9: string, // " Value="" /><%-- To Be Defined -- Non si modifica --%>
    THome: string, // " Value="" /><%-- Url Sito -- Non si modifica --%>
    TApache: string, // " Value="" /><%-- Server BPoint Web -- Non si modifica --%>
    TV: string, // " Value="0" /><%-- Tbar V/H (0=vert) -- Non si modifica --%>
    FT: string, // " Value="0" /><%-- Trace file(0=No) -- Non si modifica --%>
    FM: string, // " Value="0" /><%-- Finestra Massimizzata (0=normale) -- Non si modifica --%>

    href: string,
}

const BPointWebForm: React.FC<BPointWebParamsType> = (bpointWebParams) => {
    const ref = useRef<HTMLFormElement>(null)
    useEffect(() => {
        bpointWebParams && ref.current && ref.current.submit()
    }, [bpointWebParams])
    // console.log('BPointWebForm %o', bpointWebParams)
    return (
        <>
            <h1>Starting BPoint Web</h1>
            <form ref={ref} target="_blank" action={bpointWebParams.href} method="POST">
                <input type='hidden' value={bpointWebParams.T1} name='T1' />
                <input type='hidden' value={bpointWebParams.T2} name='T2' />
                <input type='hidden' value={bpointWebParams.T3} name='T3' />
                <input type='hidden' value={bpointWebParams.T4 ?? ''} name='T4' />
                <input type='hidden' value={bpointWebParams.T5} name='T5' />
                <input type='hidden' value={bpointWebParams.T6} name='T6' />
                <input type='hidden' value={bpointWebParams.T7} name='T7' />
                <input type='hidden' value={bpointWebParams.T8} name='T8' />
                <input type='hidden' value={bpointWebParams.T9} name='T9' />
                <input type='hidden' value={bpointWebParams.THome} name='THome' />
                <input type='hidden' value={bpointWebParams.TApache} name='TApache' />
                <input type='hidden' value={bpointWebParams.TV} name='TV' />
                <input type='hidden' value={bpointWebParams.FT} name='FT' />
                <input type='hidden' value={bpointWebParams.FM} name='FM' />
            </form>
        </>
    )
}

export default BPointWebForm